declare global {
	interface Window { prerenderReady: boolean }
}

export const prerenderMarkLoaded = () => {
	window.prerenderReady = true;
}